import React from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Icon, Message } from "semantic-ui-react";
import history from "../history";
import { startLogin, login } from "../actions/auth";

class Login extends React.Component {
  state = {
    username: "",
    password: "",
    isError: false,
    isLoading: false
  };

  componentDidMount() {
    if (!!localStorage.getItem("username")) {
      this.props.login(localStorage.getItem("username"));
      history.push("/dashboard");
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  onSubmit = async () => {
    this.setState({isLoading: true})
    await this.props.startLogin(
      this.state.username.toLowerCase(),
      this.state.password
    );

    if (!this.props.isLoggedIn) {
      this.setState({isLoading: false})
      this.setState({ isError: true });
    }
  };

  renderError = (condition) => {
    if (condition) {
      return (
        <Message
          negative
          icon="lock"
          header="Login failed!"
          content="You might have misspelled your username or password."
        ></Message>
      );
    }
  };

  render() {
    return (
      <Grid
        textAlign="center"
        style={{ height: "100vh" }}
        verticalAlign="middle"
        centered
        columns={2}
      >
        <Grid.Column>
          {this.renderError(this.state.isError)}

          <Header
            as="h2"
            textAlign="center"
            image="data:image/png;base64,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"
            content="Sign in to your account"
            style={{ marginBottom: "32px" }}
          />
          <Form size="large" onSubmit={this.onSubmit}>
            <Form.Input
              fluid
              icon="id badge"
              iconPosition="left"
              name="username"
              placeholder="Username"
              onChange={this.handleChange}
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              name="password"
              placeholder="Password"
              type="password"
              onChange={this.handleChange}
            />
            <Button
              type="submit"
              color="teal"
              disabled={this.state.isLoading}
              fluid
              size="large"
              style={{ marginBottom: "32px" }}
            >
              <Icon name="unlock alternate" />
              Sign in
            </Button>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return { isLoggedIn: state.auth.isLoggedIn };
};

export default connect(mapStateToProps, { startLogin, login })(Login);
